import { useCallback, useEffect, useState } from 'react'
import classNames from 'classnames'

import { MovementDirection } from 'components/MovementDirection/MovementDirection'
import { Slider } from 'components/ui/Slider/Slider'
import { Warehouse } from 'services/warehouse-containers/warehouse'
import { Button } from 'components/ui/Button/Button'
import {
  EmptyContainer,
  useContainersActions,
  useEmptyContainers,
} from 'services/warehouse-containers/containers'
import { Loading } from 'components/ui/Loading/Loading'
import { EmptyContainerItem } from 'components/ContainerItem/EmptyContainerItem/EmptyContainerItem'

import './containers.style.css'

export const EmptyContainers = () => {
  const [isActive, setIsActive] = useState<boolean>(false)
  const [activeContainers, setActiveContainers] = useState<EmptyContainer[]>([])
  const [currentWarehouse, setCurrentWarehouse] = useState<Warehouse>()
  const [targetWarehouse, setTargetWarehouse] = useState<Warehouse>()

  const {
    isLoading,
    emptyContainers,
    setArgs: setWarehousePair,
    args: warehousePair,
    refreshValues,
  } = useEmptyContainers()
  const { isLoading: isProcessing, transferContainers } = useContainersActions()

  useEffect(() => {
    setCurrentWarehouse(warehousePair.from as Warehouse)
    setTargetWarehouse(warehousePair.to as Warehouse)
  }, [warehousePair])

  const handleOnClose = () => setIsActive(false)

  const handleOnSearch = (fromWarehouse: Warehouse, toWarehouse: Warehouse) => {
    setWarehousePair({ from: fromWarehouse, to: toWarehouse })
  }

  const handleOnSubmit = useCallback(async () => {
    await transferContainers(
      targetWarehouse.id,
      activeContainers.map((el) => el.id)
    )

    handleOnClose()
    refreshValues()
    setActiveContainers([])
  }, [targetWarehouse, activeContainers])

  const handleOnContainerClick = (element: EmptyContainer) => {
    setActiveContainers((prev) => {
      const index = prev.findIndex((el) => el.id === element.id)

      if (index < 0) {
        return [...prev, element]
      }

      return prev.filter((_, i) => i !== index)
    })
  }

  const renderContainer = (container: EmptyContainer, index: number) => (
    <EmptyContainerItem
      key={index}
      element={container}
      onClick={handleOnContainerClick}
      highlight={activeContainers?.findIndex((el) => el.id === container.id) >= 0}
    />
  )

  const renderContainers = useCallback(() => {
    if (isLoading || isProcessing) return <Loading />

    return <div>{emptyContainers?.map(renderContainer)}</div>
  }, [isLoading, emptyContainers, activeContainers, isProcessing])

  const buttonClass = classNames('empty-containers__float-button', {
    hide: activeContainers.length === 0 || isProcessing || isLoading,
  })

  return (
    <>
      <MovementDirection
        title="Перемещение пустых контейнеров"
        fromWarehouse={currentWarehouse}
        toWarehouse={targetWarehouse}
        onSearch={handleOnSearch}
      />
      {renderContainers()}
      <div className={buttonClass}>
        <Button title="Подтвердить" handleOnSubmit={() => setIsActive(true)} />
      </div>
      <Slider isActive={isActive} onClose={handleOnClose} height="150px">
        <div className="transfer-page-list__slider">
          <h2>Переместить {activeContainers.length} контейнера(-ов)?</h2>
          <div className="transfer-page-list__slider-controlls">
            <span style={{ marginRight: '0.5rem' }}>
              <Button title="Переместить" handleOnSubmit={handleOnSubmit} />
            </span>
            <Button outline title="Отмена" handleOnSubmit={handleOnClose} />
          </div>
        </div>
      </Slider>
    </>
  )
}
